import { GroupEntity, isGroupEntity } from '@backstage/catalog-model';
import { isEntity } from '../utils';

export interface ApiGroupEntity extends GroupEntity {
  spec: ApiGroupEntitySpec;
  metadata: GroupEntity['metadata'] & {
    title: string;
    description: string;
  };
}

type ApiGroupEntitySpec = GroupEntity['spec'] & {
  type: 'api';
  apiType:
    | 'openapi'
    | 'soap'
    | 'grpc'
    | 'odata'
    | 'graphql'
    | 'asynch-api'
    | 'as2'
    | 'unknown';
  leanIxIdApplication?: string;
  leanIxIdProduct?: string;
  leanIxIdOrgUnit?: string;
  platform?: string;
  contact?: string;
  availability?: 'private' | 'public';
  authentication?: string;
  targetAudience?: string;
  costModel?: 'free' | 'request-based' | 'compute-based' | 'fixed-rates';
  consumerGroups?: ReadonlyArray<string>;
  created: string;
  updated: string;

  /**
   *  is aggregated from APIs via APIGroupAggregationProcessor
   */
  environments?: ReadonlyArray<string>;
  /**
   *  is aggregated from APIs via APIGroupAggregationProcessor
   */
  latestVersion?: string | number;
};

export function isApiGroupEntity(entity: unknown): entity is ApiGroupEntity {
  return (
    isEntity(entity) &&
    isGroupEntity(entity) &&
    isApiGroupSpec(entity.spec) &&
    (entity.metadata.name?.length ?? 0) > 0
  );
}

function isApiGroupSpec(spec: unknown): spec is ApiGroupEntitySpec {
  return (
    typeof spec === 'object' &&
    spec !== null &&
    'type' in spec &&
    spec.type === 'api' &&
    'apiType' in spec &&
    typeof spec.apiType === 'string'
  );
}
